module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "cic"
  }, [_vm._v("T")]), _vm._v("hanks to Tris Zeigler and Lucinda Denton for reading early versions of this manuscript and giving their wonderful feedback.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Thanks to Jack Harbison for the awesome brainstorming, which inspired me so much.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Finally, much gratitude to Jen Enderlin for giving me the chance to write this—I had so much fun!—and to Annelise Robey for cheerleading even through the roughest times.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01ac2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0